import { render, staticRenderFns } from "./DossierInfo.vue?vue&type=template&id=7ef8c055&"
import script from "./DossierInfo.vue?vue&type=script&lang=ts&"
export * from "./DossierInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ef8c055')) {
      api.createRecord('7ef8c055', component.options)
    } else {
      api.reload('7ef8c055', component.options)
    }
    module.hot.accept("./DossierInfo.vue?vue&type=template&id=7ef8c055&", function () {
      api.rerender('7ef8c055', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dossier/DossierInfo.vue"
export default component.exports